import { createTaxGroup as publicCreateTaxGroup, getTaxGroup as publicGetTaxGroup, updateTaxGroup as publicUpdateTaxGroup, deleteTaxGroup as publicDeleteTaxGroup, queryTaxGroups as publicQueryTaxGroups, listDefaultTaxGroups as publicListDefaultTaxGroups, listDefaultTaxGroupsByAppIds as publicListDefaultTaxGroupsByAppIds, } from './billing-v1-tax-group-tax-groups.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { onTaxGroupCreated as publicOnTaxGroupCreated } from './billing-v1-tax-group-tax-groups.public.js';
import { onTaxGroupDeleted as publicOnTaxGroupDeleted } from './billing-v1-tax-group-tax-groups.public.js';
import { onTaxGroupUpdated as publicOnTaxGroupUpdated } from './billing-v1-tax-group-tax-groups.public.js';
export const createTaxGroup = /*#__PURE__*/ createRESTModule(publicCreateTaxGroup);
export const getTaxGroup = /*#__PURE__*/ createRESTModule(publicGetTaxGroup);
export const updateTaxGroup = /*#__PURE__*/ createRESTModule(publicUpdateTaxGroup);
export const deleteTaxGroup = /*#__PURE__*/ createRESTModule(publicDeleteTaxGroup);
export const queryTaxGroups = /*#__PURE__*/ createRESTModule(publicQueryTaxGroups);
export const listDefaultTaxGroups = /*#__PURE__*/ createRESTModule(publicListDefaultTaxGroups);
export const listDefaultTaxGroupsByAppIds = /*#__PURE__*/ createRESTModule(publicListDefaultTaxGroupsByAppIds);
/**
 * Triggered when a tax group is created.
 */
export const onTaxGroupCreated = createEventModule(publicOnTaxGroupCreated);
/**
 * Triggered when a tax group is deleted.
 */
export const onTaxGroupDeleted = createEventModule(publicOnTaxGroupDeleted);
/**
 * Triggered when a tax group is updated.
 */
export const onTaxGroupUpdated = createEventModule(publicOnTaxGroupUpdated);
export { SortOrder, WebhookIdentityType, } from './billing-v1-tax-group-tax-groups.universal.js';
//# sourceMappingURL=billing-v1-tax-group-tax-groups.context.js.map